"use client";
import { IProducts } from "@/api/AppApi/services/home/interfaces/IProduct";
import { carouselSpeed } from "@/utils/functions/functions";
import { IProduct_Category_Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { getProductBoxDefaultDimAndSpacing } from "../common/functions";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import useInteractionStart from "@/hooks/useInteractionStart";
import { JSX } from "react";

interface Props {
  products: IProducts;
  setIslastProduct?: (isLastProduct: boolean) => void;
  id?: string | number;
}
const ProductEmblaSlider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  products,
  setIslastProduct,
  id,
}) => {
  const { isInteracting } = useInteractionStart();
  const speed = carouselSpeed(
    (products.configurations?.customize as IProduct_Category_Config_Customize)
      ?.interval,
  );
  const data = products?.data ?? [];
  const size = products?.configurations?.style_type ?? Size.small;
  const { width, spacing } = getProductBoxDefaultDimAndSpacing(size);
  if (data.length === 0) return null;

  return (
    <EmblaSlider
      autoPlay={!!speed && isInteracting}
      autoplayDuration={speed}
      setisLastSlide={setIslastProduct}
    >
      <EmblaSlider.EmblaSliderViewport id={id}>
        <EmblaSlider.EmblaSliderContainer
          gap={spacing}
          slides={[
            ...(children as Array<JSX.Element>)?.map((child) => ({
              component: <div style={{ width }}>{child}</div>,
              width: "auto" as TSlideWidith,
            })),
          ]}
          id={id}
        />
        <EmblaSlider.EmblaFilters />
        <EmblaSlider.EmblaSliderPrevNextButtons />
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default ProductEmblaSlider;
